import {
  StyleSheet,
  ImageBackground,
  useWindowDimensions,
  SafeAreaView,
  Image,
} from "react-native";
import React from "react";

import {
  View,
  ScrollView,
  Heading,
  Text,
  Pressable,
  Box,
  VStack,
  Center,
  HStack,
} from "native-base";
import Card from "../../components/Card";
import { StackScreenProps } from "../../types";
import { LinearGradient } from "expo-linear-gradient";
import Header from "../../components/Header";

const SmartBlenders = ({ navigation }: StackScreenProps<"ResearchAndDev">) => {
  const { height, width } = useWindowDimensions();

  const objectives = [
    "To introduce smart blenders in 6 locations across (Niger, Benue, Kebbi, Ebonyi, Delta and C/River) States in Nigeria to serve as pilot for the study of the productivity and economic impact of localizing production of customized fertilizer within farming hubs ",
    "To create entrepreneures and employment opportunities and provide data and learning points for the planned scaling up of the deployment of smart blenders to many more communities ",
    "To conduct and popularize soil testing and produce interactive digital soil and fertility maps as a means of deriving soil and crop specific fertilizers for improving the yield of staple crops such as rice, maize and soybeans.",
  ];

  return (
    <ImageBackground
      source={require("../../assets/smart_blenders.png")}
      resizeMode="cover"
      style={{ width, height }}
    >
      <View style={styles.overlay}>
        <SafeAreaView style={{ height }}>
          <ScrollView>
            <Header
              onPress={() => navigation.navigate("Production")}
              parentText="Production"
              headingText="Smart Blenders"
              intro="Project Goal: To efficiently increase yields and agricultural productivity through site and crop specific fertilizer use"
            />

            <Text textAlign="center" mb={3} fontSize="xs">
              Project Objective:
            </Text>

            <HStack space={3} mb={5} px={10} justifyContent="center">
              {objectives.map((itm, i) => (
                <Box flex={1} height={300} borderRadius={5} key={itm}>
                  <LinearGradient
                    colors={[
                      "rgba(255, 155, 155, 1)",
                      "rgba(203, 144, 144, 1)",
                    ]}
                    style={{
                      width: "100%",
                      height: "100%",
                      padding: 5,
                      borderRadius: 5,
                    }}
                  >
                    <Heading
                      fontSize={"sm"}
                      mb={3}
                      textAlign="center"
                      color="#520000"
                    >
                      Objective {i + 1}
                    </Heading>
                    <Text
                      fontSize={"xs"}
                      lineHeight="xs"
                      color="#333"
                      textAlign={"center"}
                    >
                      {itm}
                    </Text>
                  </LinearGradient>
                </Box>
              ))}
            </HStack>

            <Box w="5/6" h={350} margin="auto">
              <ImageBackground
                source={require("../../assets/blenders.png")}
                style={{
                  width: "100%",
                  height: "100%",
                  borderRadius: 35,
                  overflow: "hidden",
                  borderWidth: 5,
                  borderColor: "white",
                }}
                imageStyle={{
                  borderRadius: 15,
                  backgroundColor: "rgba(0,0,0,.8)",
                }}
              >
                <Center style={styles.cardOverlay}>
                  {/* <Image
                    source={require("../../assets/playicon.png")}
                    style={{ height: 40, width: 40 }}
                  /> */}
                  <iframe
                    src="https://www.youtube.com/embed/aW7PeGMwbHM"
                    title=""
                    style={{
                      width: "100%",
                      height: "100%",
                      borderRadius: 15,
                      overflow: "hidden",
                      borderWidth: 2,
                      borderColor: "white",
                    }}
                    // frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    // allowfullscreen
                  ></iframe>
                </Center>
              </ImageBackground>
            </Box>

            <View style={{ height: 20 }}></View>
          </ScrollView>
        </SafeAreaView>
      </View>
    </ImageBackground>
  );
};

export default SmartBlenders;

const styles = StyleSheet.create({
  shadow: {
    shadowOffset: { width: 0, height: 20 },
    shadowRadius: 20,
    shadowOpacity: 0.6,
    shadowColor: "#000000",
    elevation: 20,
  },
  buttonShadow: {
    shadowOffset: { width: 0, height: 2 },
    shadowRadius: 1,
    shadowOpacity: 0.3,
    shadowColor: "#000000",
    elevation: 5,
  },
  overlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "#540114e6",
  },
  cardOverlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "rgba(0, 0, 0, 0.1)",
  },
});
